const productData = {
        title: 'SHEAVERA Fruit Toner',
        variant: 'Fruit Toner',
        price: '23.00',
        variantId: '49772560810230',
        quantity: 1,
        image: 'https://cdn.shopify.com/s/files/1/0773/7756/9014/files/TONER.jpg?v=1762512866'
    };

    let currentQuantity = 1;
    let countdownInterval;
    let totalSeconds = 14 * 24 * 60 * 60;

    function updateCountdownDisplay() {
        const days = Math.floor(totalSeconds / (24 * 60 * 60));
        const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
        const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
        const seconds = totalSeconds % 60;

        const daysElement = document.getElementById('countdownDays');
        const hoursElement = document.getElementById('countdownHours');
        const minutesElement = document.getElementById('countdownMinutes');
        const secondsElement = document.getElementById('countdownSeconds');

        if (daysElement) daysElement.textContent = String(days).padStart(2, '0');
        if (hoursElement) hoursElement.textContent = String(hours).padStart(2, '0');
        if (minutesElement) minutesElement.textContent = String(minutes).padStart(2, '0');
        if (secondsElement) secondsElement.textContent = String(seconds).padStart(2, '0');
    }

    function startCountdown() {
        if (countdownInterval) clearInterval(countdownInterval);
        updateCountdownDisplay();

        countdownInterval = setInterval(() => {
            if (totalSeconds <= 0) {
                totalSeconds = 14 * 24 * 60 * 60;
            } else {
                totalSeconds--;
            }
            updateCountdownDisplay();
        }, 1000);
    }

    function initCollapsibles() {
        const collapsibles = document.querySelectorAll('.collapsible-item');

        collapsibles.forEach(coll => {
            const header = coll.querySelector('.collapsible-header');
            const content = coll.querySelector('.collapsible-content');
            const iconSpan = header ? header.querySelector('.collapsible-icon') : null;

            if (!header || !content || !iconSpan) return;

            header.setAttribute('role', 'button');
            header.setAttribute('tabindex', '0');
            header.setAttribute('aria-expanded', 'false');

            const toggle = () => {
                const isOpen = content.classList.contains('open');
                content.classList.toggle('open', !isOpen);
                iconSpan.textContent = isOpen ? '+' : '−';
                iconSpan.classList.toggle('open', !isOpen);
                header.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
            };

            header.addEventListener('click', toggle);
            header.addEventListener('keydown', event => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggle();
                }
            });

            content.classList.remove('open');
            iconSpan.textContent = '+';
        });
    }

    document.addEventListener('DOMContentLoaded', function() {
        startCountdown();
        initCollapsibles();

        const thumbnails = Array.from(document.querySelectorAll('.thumbnail'));
        const mainImageBox = document.getElementById('mainImage');
        const mainImage = document.getElementById('currentImage');
        let activeImageIndex = Math.max(0, thumbnails.findIndex(item => item.classList.contains('active')));
        let galleryAnimating = false;
        let pointerStartX = 0;
        let pointerDeltaX = 0;
        let pointerActive = false;

        function updateActiveThumbnail(index) {
            thumbnails.forEach((item, itemIndex) => item.classList.toggle('active', itemIndex === index));
        }

        function changeGalleryImage(index, direction = 0) {
            if (!mainImage || galleryAnimating || !thumbnails.length) return;
            const safeIndex = (index + thumbnails.length) % thumbnails.length;
            if (safeIndex === activeImageIndex && mainImage.src) return;

            galleryAnimating = true;
            const outgoingClass = direction < 0 ? 'gallery-swipe-out-right' : 'gallery-swipe-out-left';
            const incomingClass = direction < 0 ? 'gallery-swipe-enter-right' : 'gallery-swipe-enter-left';
            mainImage.classList.add(outgoingClass);

            window.setTimeout(() => {
                const newImage = thumbnails[safeIndex].getAttribute('data-image');
                mainImage.classList.remove('gallery-swipe-out-left', 'gallery-swipe-out-right');
                mainImage.classList.add(incomingClass);
                mainImage.src = newImage;
                productData.image = newImage;
                activeImageIndex = safeIndex;
                updateActiveThumbnail(activeImageIndex);

                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        mainImage.classList.remove('gallery-swipe-enter-left', 'gallery-swipe-enter-right');
                        galleryAnimating = false;
                    });
                });
            }, 220);
        }

        thumbnails.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', function() {
                if (index === activeImageIndex) return;
                changeGalleryImage(index, index > activeImageIndex ? 1 : -1);
            });
        });

        if (mainImageBox && mainImage) {
            mainImageBox.addEventListener('pointerdown', function(event) {
                if (galleryAnimating) return;
                pointerActive = true;
                pointerStartX = event.clientX;
                pointerDeltaX = 0;
                mainImageBox.classList.add('is-dragging');
                if (mainImageBox.setPointerCapture) mainImageBox.setPointerCapture(event.pointerId);
            });

            mainImageBox.addEventListener('pointermove', function(event) {
                if (!pointerActive || galleryAnimating) return;
                pointerDeltaX = event.clientX - pointerStartX;
                const resistance = Math.max(-90, Math.min(90, pointerDeltaX * 0.35));
                mainImage.style.transition = 'none';
                mainImage.style.transform = `translateX(${resistance}px)`;
            });

            const finishSwipe = function(event) {
                if (!pointerActive) return;
                pointerActive = false;
                mainImageBox.classList.remove('is-dragging');
                if (mainImageBox.releasePointerCapture && event && mainImageBox.hasPointerCapture && mainImageBox.hasPointerCapture(event.pointerId)) {
                    mainImageBox.releasePointerCapture(event.pointerId);
                }
                mainImage.style.transition = '';
                mainImage.style.transform = '';

                if (Math.abs(pointerDeltaX) >= 45) {
                    changeGalleryImage(activeImageIndex + (pointerDeltaX < 0 ? 1 : -1), pointerDeltaX < 0 ? 1 : -1);
                }
                pointerDeltaX = 0;
            };

            mainImageBox.addEventListener('pointerup', finishSwipe);
            mainImageBox.addEventListener('pointercancel', finishSwipe);
            mainImageBox.addEventListener('pointerleave', function(event) {
                if (pointerActive && event.pointerType === 'mouse') finishSwipe(event);
            });
        }

        const buyButtons = document.querySelectorAll('.buy-button');
        buyButtons.forEach(button => {
            button.addEventListener('click', function() {
                buyButtons.forEach(item => item.classList.remove('selected'));
                this.classList.add('selected');
                currentQuantity = parseInt(this.dataset.quantity, 10) || 1;
                productData.price = this.dataset.price || '23.00';
                productData.quantity = currentQuantity;
                updateCartButtonText();
            });
        });

        const addToCartBtn = document.getElementById('addToCart');
        if (addToCartBtn) {
            addToCartBtn.addEventListener('click', handleAddToCartClick);
            updateCartButtonText();
        }

        const whatsappBtn = document.getElementById('whatsappButton');
        if (whatsappBtn) {
            whatsappBtn.addEventListener('click', function() {
                const message = `Hi! I'm interested in purchasing ${productData.title} from your website.\n\nProduct: ${productData.title}\nQuantity: ${currentQuantity}\nTotal: $${parseFloat(productData.price).toFixed(2)}\n\nCan you help me with the order?`;
                this.href = `https://wa.me/96181446674?text=${encodeURIComponent(message)}`;
            });
        }

        if (window.innerWidth > 768) {
            const productImages = document.querySelector('.product-images');
            const container = document.querySelector('.product-page-container');
            const headerHeight = 80;

            if (productImages && container) {
                window.addEventListener('scroll', function() {
                    const scrollPosition = window.pageYOffset;
                    const containerTop = container.offsetTop;
                    const containerHeight = container.offsetHeight;
                    const windowHeight = window.innerHeight;

                    if (scrollPosition > containerTop - headerHeight) {
                        productImages.style.top = `${headerHeight}px`;
                        const distanceFromBottom = containerTop + containerHeight - (scrollPosition + windowHeight);
                        if (distanceFromBottom < 100) {
                            productImages.style.top = `calc(${windowHeight - distanceFromBottom - 100}px)`;
                        }
                    } else {
                        productImages.style.top = `${containerTop - scrollPosition + headerHeight}px`;
                    }
                });
            }
        }

        const reviewsLink = document.querySelector('a.rating-count');
        if (reviewsLink) {
            reviewsLink.addEventListener('click', function(e) {
                e.preventDefault();
                const reviewsSection = document.getElementById('fruit-toner-reviews-section');
                if (reviewsSection) {
                    reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                } else {
                    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                }
            });
        }
    });

    function updateCartButtonText() {
        const addToCartBtn = document.getElementById('addToCart');
        if (!addToCartBtn) return;
        const labelSpan = addToCartBtn.querySelector('span');
        if (labelSpan) labelSpan.textContent = `Add to Cart - $${parseFloat(productData.price).toFixed(2)}`;
    }

    function handleAddToCartClick() {
        const addToCartBtn = document.getElementById('addToCart');
        if (!addToCartBtn) return;

        productData.quantity = parseInt(currentQuantity) || 1;
        addToCartBtn.classList.add('added');
        addToCartBtn.innerHTML = `
            <svg viewBox="0 0 24 24"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
            <span>Adding...</span>
        `;

        const finalizeButton = (success) => {
            if (!addToCartBtn) return;

            if (success) {
                showNotification(productData.title + ' added to cart!');
                addToCartBtn.innerHTML = `
                    <svg viewBox="0 0 24 24"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                    <span>Added to Cart</span>
                `;

                setTimeout(() => {
                    addToCartBtn.classList.remove('added');
                    addToCartBtn.innerHTML = `
                        <svg viewBox="0 0 24 24"><path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/></svg>
                        <span>Add to Cart - $${parseFloat(productData.price).toFixed(2)}</span>
                    `;
                }, 2000);
            } else {
                addToCartBtn.classList.remove('added');
                updateCartButtonText();
            }
        };

        if (typeof window.addToCart === 'function') {
            try {
                const result = window.addToCart(productData.variantId, productData.quantity);
                if (result && typeof result.then === 'function') {
                    result
                        .then(() => finalizeButton(true))
                        .catch(err => { console.error(err); finalizeButton(false); });
                } else {
                    finalizeButton(true);
                }
            } catch (err) {
                console.error(err);
                finalizeButton(false);
            }
        } else {
            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({
                    id: productData.variantId,
                    quantity: productData.quantity,
                    properties: {
                        '_Bundle offer': `Buy ${productData.quantity}`,
                        '_Bundle display total': `$${parseFloat(productData.price).toFixed(2)}`
                    }
                })
            })
            .then(r => r.ok ? r.json() : r.json().then(e => { throw e; }))
            .then(() => finalizeButton(true))
            .catch(err => { console.error(err); finalizeButton(false); });
        }
    }

    function showNotification(message) {
        const notification = document.getElementById('cartNotification');
        const messageElement = document.getElementById('notificationMessage');
        if (!notification || !messageElement) return;

        messageElement.textContent = message;
        notification.style.display = 'flex';
        setTimeout(() => { notification.style.display = 'none'; }, 3000);
    }
